export const siteUrl =
	import.meta.env.VITE_SITE_URL ||
	import.meta.env.VITE_BETTER_AUTH_URL ||
	"http://localhost:3000";

const availableOgImageSlugs = new Set([
	"blog",
	"default",
	"help",
	"pricing",
	"privacy",
	"terms",
	"mcp",
	"webinar",
	"alternatives-buffer",
	"alternatives-hootsuite",
	"linkedin-scheduler",
	"x-scheduler",
	"bluesky-scheduler",
	"threads-scheduler",
	"instagram-scheduler",
	"tiktok-scheduler",
	"youtube-scheduler",
	"facebook-scheduler",
	"pinterest-scheduler",
	"claude-social-media",
	"claude-code-social-media",
	"chatgpt-social-media",
	"cursor-social-media",
	"codex-social-media",
	"openclaw-social-media",
	"gemini-social-media",
	"for-founders",
	"for-agencies",
	"for-creators",
	"for-b2b-saas",
	"for-ecommerce",
	"features-ai-scheduling",
	"features-cross-posting",
	"features-calendar",
	"features-team-approval",
]);

const ogImageAliases = new Map([
	["mcp-server", "mcp"],
	["channels-linkedin", "linkedin-scheduler"],
	["channels-x", "x-scheduler"],
	["channels-bluesky", "bluesky-scheduler"],
	["channels-threads", "threads-scheduler"],
	["channels-instagram", "instagram-scheduler"],
	["channels-tiktok", "tiktok-scheduler"],
	["channels-youtube", "youtube-scheduler"],
	["channels-facebook", "facebook-scheduler"],
	["channels-pinterest", "pinterest-scheduler"],
]);

export function ogSlugForPath(internalPath: string): string {
	const trimmed = internalPath.replace(/^\//, "").replace(/\/$/, "");
	if (!trimmed) return "default";
	return trimmed.replace(/\//g, "-");
}

export function getLocalizedSeoUrls(_opts: {
	matches?: unknown;
	internalPath: string;
	trailingSlash?: boolean;
}) {
	return {
		canonicalUrl: `${siteUrl}${_opts.internalPath}`,
	};
}

export function ogImageUrl(slug = "default"): string {
	const normalizedSlug = ogImageAliases.get(slug) ?? slug;
	const safeSlug = availableOgImageSlugs.has(normalizedSlug)
		? normalizedSlug
		: "default";
	return `${siteUrl}/og/${safeSlug}.png`;
}

export function buildLocalizedSeoLinks(_opts: {
	matches?: unknown;
	internalPath: string;
	trailingSlash?: boolean;
}) {
	return [{ rel: "canonical", href: `${siteUrl}${_opts.internalPath}` }];
}

export function noIndexMeta() {
	return [{ name: "robots", content: "noindex, nofollow" }];
}
